import React from 'react';
import { Button, Box } from '@mui/material';

const AuthButton = ({
  children, disabled, loading, onClick, type = 'submit', sx = {},
}) => (
  <Box sx={{ mt: '32px', width: '100%' }}>
    <Button
      type={type}
      variant="contained"
      fullWidth
      size="large"
      disabled={disabled || loading}
      onClick={onClick}
      sx={{
        width: '100%',
        maxWidth: '740px',
        height: '63px',
        borderRadius: '8px',
        backgroundColor: '#007BC6',
        fontWeight: 700,
        fontSize: '15px',
        textTransform: 'none',
        boxShadow: 'none',
        mt: '-16px',
        '&:hover': { backgroundColor: '#005F9E', boxShadow: 'none' },
        '&.Mui-disabled': { backgroundColor: '#B0C4D8', color: '#fff' },
        ...sx,
      }}
    >
      {loading ? 'Chargement...' : children}
    </Button>
  </Box>
);

export default AuthButton;
